import { gql } from "@apollo/client"

import { ADMIN_FRAGMENT } from "lib/fragments"
import { useMeQuery } from "lib/graphql"

void gql`
  query Me {
    meAdmin {
      ...Admin
    }
  }
  ${ADMIN_FRAGMENT}
`
type UseMeQueryOptions = Parameters<typeof useMeQuery>[0]
export function useMe(options?: UseMeQueryOptions) {
  const res = useMeQuery(options)
  return { me: res.data?.meAdmin, ...res }
}
